import { forwardRef, ReactNode, Ref } from 'react';
import classNames from 'classnames';

import { FieldState } from 'components/Form/types';

type LeadingAddOnProps = {
  leadingAddOn?: ReactNode | string;
  state?: FieldState;
  show: boolean;
};

export const LeadingAddOn = forwardRef(
  ({ leadingAddOn, state = 'default', show }: LeadingAddOnProps, ref: Ref<HTMLDivElement>) => {
    return (
      <div
        ref={ref}
        className={classNames({
          'absolute inset-y-0 left-0 flex items-center pl-3': show,
          'pointer-events-none': typeof leadingAddOn === 'string' && show,
          'size-0': !show,
        })}
      >
        {show && leadingAddOn ? (
          <span
            className={classNames(
              {
                'text-gray-500': state === 'default',
                'text-blue-500': state === 'pending-validation',
              },
              'group-focus-within:text-gray-500 sm:text-sm h-full flex items-center',
            )}
          >
            {leadingAddOn}
          </span>
        ) : null}
      </div>
    );
  },
);

LeadingAddOn.displayName = 'LeadingAddOn';
